import { SacClientModule } from './../../widgets/control/sac-client/sac-client.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ActionTabletModule, ActionTabletRegistryService, CommonLayoutModule, CommonUIModule } from '@sdbn/common';
import { TransportDetailsModule } from './../../common/components/transport-details/transport-details.module';
import { ActionTabletRefusedLeaveComponent } from './action-tablet-refused-leave/action-tablet-refused-leave.component';
import { ActionTabletTransportModule } from './action-tablet-transport/action-tablet-transport.module';
import { ActionTabletPlannedAssignmentsComponent } from './action-tablet-planned-assignments/action-tablet-planned-assignments.component';
import { ActionTabletPlannedAssignmentDetailsComponent } from './action-tablet-planned-assignments/action-tablet-planned-assignment-details/action-tablet-planned-assignment-details.component';
import { ActionTabletPlannedAssignmentsActionDialogComponent } from './action-tablet-planned-assignments/action-tablet-planned-assignments-action-dialog/action-tablet-planned-assignments-action-dialog.component';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";



@NgModule({
  declarations: [
    ActionTabletRefusedLeaveComponent,
    ActionTabletPlannedAssignmentsComponent,
    ActionTabletPlannedAssignmentDetailsComponent,
    ActionTabletPlannedAssignmentsActionDialogComponent
  ],
  imports: [
    CommonModule,
    ActionTabletTransportModule,
    ActionTabletModule,
    CommonLayoutModule,
    TransportDetailsModule,
    CommonUIModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    SacClientModule
]
})
export class ControlModule {

  constructor(
    actionTabletRegistryService: ActionTabletRegistryService,
  ) {

    actionTabletRegistryService.registerType('refusedLeave', ActionTabletRefusedLeaveComponent);
    actionTabletRegistryService.registerType('plannedAssignments', ActionTabletPlannedAssignmentsComponent);

  }

}
